import { useEffect, useMemo } from "react"

import { useMapDispatchContext, useMapStateContext } from "@l2r-front/l2r-map"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"
import { BottomSheetHeights, useApplicationStateContext } from "@l2r-front/l2r-utils"

import * as Styled from "./MapWithPhotoViewer.styled"

export function MapWithPhotoViewer(props) {

    const { className, children, ...otherProps } = props
    const { mapHeightPct } = useMapStateContext()
    const { currentBottomSheetHeight } = useApplicationStateContext()
    const isMobile = useIsMobileDevice()
    const { getMapRef } = useMapDispatchContext()
    const map = useMemo(() => {
        return getMapRef()?.getMap()
    }, [getMapRef])

    useEffect(() => {
        const frame = requestAnimationFrame(() => {
            if (map) {
                map.resize()
            }
        })
        return () => cancelAnimationFrame(frame)
    }, [map, mapHeightPct])

    return <Styled.MapWithPhotoViewerContainer className={className} fullScreenMode={!isMobile && mapHeightPct === 0}>
        {mapHeightPct !== 100 ? <Styled.ImageViewerContainer mapHeightPct={mapHeightPct} /> : null}
        <Styled.Map {...otherProps} displayAnchorElements={!isMobile || (mapHeightPct > 50 && currentBottomSheetHeight <= BottomSheetHeights.FULL)} mapHeightPct={mapHeightPct}>
            {children}
        </Styled.Map>
    </Styled.MapWithPhotoViewerContainer>
}

MapWithPhotoViewer.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
}